export default function bunnyImageLoader({ src, width, quality }) {
  const url = new URL(getCDNURL(src))
  url.searchParams.set("width", width.toString())
  if (quality) {
    url.searchParams.set("quality", quality.toString())
  }

  return url.href
}

export function getCDNURLWithParams({ pathName, width, quality }) {
  const url = new URL(getCDNURL(pathName))
  if (width) {
    url.searchParams.set("width", width.toString())
  }
  if (quality) {
    url.searchParams.set("quality", quality.toString())
  }
  return url.href
}

/**
 * Gets url for the image from the CDN in production
 * @param pathName relative path to the image
 */
function getCDNURL(pathName) {
  return `${process.env.NEXT_PUBLIC_CDN_URL}${pathName}`
}
